// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
import type * as SchemaTypes from '../../../../graphql/api/index';

import { gql } from 'graphql-tag';
import { ImageLargeFragmentDoc } from '../../imageLarge.fragment.generated';
export const BlogPostPreviewFragmentDoc = gql`
    fragment blogPostPreview on Post {
  id
  title
  slug
  excerpt
  date
  featuredImage {
    ...imageLarge
  }
}
    ${ImageLargeFragmentDoc}`;